import { UiAlertsStore } from "../../Common/_stores/UiAlertsStore";

export const BudgetsUiAlertsActions = {
    showSuccessAlert: UiAlertsStore.actionSuccessAlert,
    showErrorAlert: UiAlertsStore.actionErrorAlert,
    clearAlert: UiAlertsStore.actionClearAlert,
};